/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import Cuestionario from './Cuestionario';
import * as validations from '../../validations/validations';
import * as formularioActions from '../../actions/formularioActions';
import * as paginaActions from '../../actions/paginaActions';
import * as preguntarespuestaActions from '../../actions/preguntarespuestaActions';

import {  useParams } from "react-router-dom";
import {Auth} from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react'
import { Segment} from 'semantic-ui-react'; 
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
 import {getMargenes} from '../../util/';


class ManageCuestionario extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            strings:[],
            permisos:{},
            datosGenerales:{},
            formulario:[],
            preguntaRespuesta:[]
		};
	}
   
    async checkUser(){
        try{
            const data =await Auth.currentUserPoolUser();
            const userInfo={username:data.username, ...data.attributes};
            this.setState({"userInfo": userInfo});
        }catch (err){
            //console.log('error:', err)
        }
    }

    componentDidMount(){
        this.checkUser();
		this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
        
        this.props.formularioActions.getFormulario(1, this.props.user).then(formulario=>{
                let datos = this.state.formulario;
                datos.push(formulario);
                this.setState({"formulario":datos});
           })
            .catch(error=>{
              toastr.error(error);
            });
        
        this.props.preguntarespuestaActions.getPreguntaRespuesta(27, this.props.user).then(respuestas=>{
                let datosGenerales = this.state.datosGenerales;
                
                for(let i=0; i<respuestas.length;i++){
                    if(respuestas[i].tipo == 'input' || respuestas[i].tipo == 'textArea'){
                        datosGenerales[respuestas[i].idPregunta]=respuestas[i].textoRespuesta;
                    } else{
                        if(respuestas[i].consecutivoRespuesta==0){
                            datosGenerales[respuestas[i].idPregunta]=respuestas[i].value;
                        }else{
                            datosGenerales[respuestas[i].idPregunta+'_'+respuestas[i].idRespuesta]=1;
                        }    
                    }   
                }
                this.setState({"datosGenerales":datosGenerales});
           })
            .catch(error=>{
              toastr.error(error);
            });
        
    }
    
    buscarSeccionFormulario=(formulario, data)=>{
        let index;
        let nombre;
        if(data.type=='checkbox' || data.type=='file'){
            nombre=data.name.split('_');
        }
        
        for(let i=0;i<formulario.length;i++){
            if(data.type=='checkbox' || data.type=='file'){
                index = formulario[i].pregunta.findIndex(pregunta=>pregunta.id==nombre[0]);
            }else{
                index = formulario[i].pregunta.findIndex(pregunta=>pregunta.id==data.name);
            }
            if(index!=-1){
                return formulario[i].pregunta[index];        
                break;
            }
        }
    }
    
    handleRespuestaPregunta=(event,data)=>{
        
        let formulario = this.state.formulario;
        let preguntaRespuesta=this.state.preguntaRespuesta;
        let seccion = this.buscarSeccionFormulario(formulario, data);
        let resp={};
        let index;
        let nombre;
        let indexPregunta;
        
        if(data.type=='checkbox' || data.type=='file'){
            nombre=data.name.split('_');
            indexPregunta = preguntaRespuesta.findIndex(e=>e.idPregunta==nombre[0] && e.idRespuesta==nombre[1]);
        }else{
            indexPregunta = preguntaRespuesta.findIndex(e=>e.idPregunta==seccion.id);
        }
        
        
    
        if(seccion.respuestaList.length>0){
            if(indexPregunta!=-1){        
                if(data.type=='checkbox' || data.type=='file'){
                    preguntaRespuesta[indexPregunta].borrar = !data.checked;
                }else{
                    index = seccion.respuestaList.findIndex(opciones=>opciones.value==data.value);
                    preguntaRespuesta[indexPregunta].idRespuesta = seccion.respuestaList[index].id;
                }    
            }else{
                
                if(data.type=='checkbox' || data.type=='file'){
                    nombre=data.name.split('_');
                    resp.idPregunta = nombre[0];  
                }else{
                    resp.idPregunta = seccion.id;
                }
                

                
                index = seccion.respuestaList.findIndex(opciones=>opciones.value==data.value);
                resp.idRespuesta = seccion.respuestaList[index].id;
                resp.usuarioEmail = this.state.userInfo.email;  
                resp.consecutivoRespuesta = seccion.respuestaList[index].value;  
                resp.tipo=seccion.tipo;
                resp.borrar=!data.checked;
                preguntaRespuesta.push(resp);
                
            }    
        }else{
            
            if(indexPregunta!=-1){        
                preguntaRespuesta[indexPregunta].textoRespuesta = data.value;
            }else{
                resp.idPregunta = seccion.id;
                resp.textoRespuesta = data.value;
                resp.usuarioEmail = this.state.userInfo.email;
                resp.tipo=seccion.tipo;
                preguntaRespuesta.push(resp);
            }
            
            
        }
        this.setState({preguntaRespuesta:preguntaRespuesta});
    }
    

    handleChangeFormulario=(event, data)=> {

        let datosGenerales = this.state.datosGenerales;
        let field= data.name;		
        let value;
        
        this.handleRespuestaPregunta(event,data);
        
        if(data.type == 'checkbox'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
       
        field=field.toString();
        field=field.split('.');

        if(field.length==1)
            datosGenerales[field[0]]= value;
        else{
             if(!datosGenerales[field[0]]){
                    datosGenerales[field[0]]={}
                }
            datosGenerales[field[0]][field[1]]= value;
        }
		
		
        this.setState({"datosGenerales": datosGenerales});
        
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let datosGenerales=this.state.datosGenerales;
              
        if(!validations.requerido(datosGenerales.descripcion)){
            errors.datosGenerales=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        
        event.preventDefault();
        /*
        if(!this.FormIsValid()){
            return ;
        }
       */
        
        this.props.preguntarespuestaActions.save(this.state.preguntaRespuesta, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
        });
        
        
        
    }

       
    render() {	
          let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		
       return (
              <Segment  style={margenes}>
                <Cuestionario 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    formulario={this.state.formulario}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    datosGenerales={this.state.datosGenerales}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    let id = ownProps.match.params.id;

    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        color:state.color,
        permisos:state.permisos,
        user:state.user,
        idioma:state.idioma,
        form:state.form
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        preguntarespuestaActions: bindActionCreators(preguntarespuestaActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCuestionario);